import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

export async function reviewCode(code, language) {
  const systemInstruction = `
    You are an expert senior software engineer and a world-class code reviewer. 
    Your task is to provide a thorough, constructive, and friendly code review.
    Analyze the given code for the following aspects:
    1.  **Code Quality & Readability**: Is the code clean, well-structured, and easy to understand?
    2.  **Potential Bugs**: Are there any logical errors, edge cases not handled, or potential runtime issues?
    3.  **Performance**: Are there any performance bottlenecks? Can the code be optimized?
    4.  **Security**: Are there any security vulnerabilities (e.g., injection attacks, data exposure)?
    5.  **Best Practices & Conventions**: Does the code adhere to the language's best practices and common conventions?
    
    Provide specific, actionable suggestions for improvement. 
    Organize your feedback into logical sections.
    Use Markdown for formatting, including code blocks for examples.
    Start with a brief, high-level summary of the code's quality.
    Be encouraging and maintain a positive tone.
  `;

  const prompt = `
    ${systemInstruction}

    Please review the following ${language} code.

    \`\`\`${language.toLowerCase()}
    ${code}
    \`\`\`
  `;
  
  try {
    const reviewCodeFn = httpsCallable(functions, 'reviewCode');
    const result = await reviewCodeFn({ code, language });
    return result.data;
  } catch (error) {
    console.error("Error calling Gemini API:", error);
    throw new Error("An error occurred while fetching the code review.");
  }
}

export async function generateCode(description, language) {
  const systemInstruction = `
    You are an expert software engineer.
    Your task is to generate high-quality, production-ready code based on the user's description.
    The code must be written in ${language}.
    Ensure the code is well-commented, efficient, and follows best practices for the specified language.
    Only output the code, enclosed in markdown code blocks. Do not provide extensive explanations unless necessary.
  `;

  const prompt = `
    ${systemInstruction}
    
    Please generate code for the following description:
    ${description}
  `;

  try {
    const generateCodeFn = httpsCallable(functions, 'generateCode');
    const result = await generateCodeFn({ description, language });
    return result.data;
  } catch (error) {
    console.error("Error calling Gemini API:", error);
    throw new Error("An error occurred while generating code.");
  }
}
